import SectionTitle from '../../components/Common/SectionTitle';
import SingleServiceTwo from '../../components/Service/SingleServiceTwo';

// Service Image Icons
import mainIcon1 from '../../assets/img/service/style2/main-img/1.png';
import hoverIcon1 from '../../assets/img/service/style2/hover-img/1.png';
import mainIcon2 from '../../assets/img/service/style2/main-img/2.png';
import hoverIcon2 from '../../assets/img/service/style2/hover-img/2.png';
import mainIcon3 from '../../assets/img/service/style2/main-img/3.png';
import hoverIcon3 from '../../assets/img/service/style2/hover-img/3.png';
import mainIcon4 from '../../assets/img/service/style2/main-img/4.png';
import hoverIcon4 from '../../assets/img/service/style2/hover-img/4.png';
import mainIcon5 from '../../assets/img/service/style2/main-img/5.png';
import hoverIcon5 from '../../assets/img/service/style2/hover-img/5.png';
import mainIcon6 from '../../assets/img/service/style2/main-img/6.png';
import hoverIcon6 from '../../assets/img/service/style2/hover-img/6.png';

const Service = () => {

    return (
        <div id="rs-service" className="rs-services style3 pt-110 pb-100 md-pt-74 md-pb-60">
            <div className="container">
                <div className="row mb-40">
                    <div className="col-lg-6 col-md-6 mb-20">
                        <SingleServiceTwo
                            itemClass="services-item category-card"
                            prefix="BD"
                            mainIcon={mainIcon5}
                            hoverIcon={hoverIcon5}
                            Title="Business Development"
                            serviceURL="business-development"
                            Text="Market analysis, strategy, partnerships, and go-to-market execution designed to help businesses grow and expand with confidence."
                        />
                    </div>
                    <div className="col-lg-6 col-md-6 mb-20">
                        <SingleServiceTwo
                            itemClass="services-item category-card"
                            prefix="IT"
                            mainIcon={mainIcon6}
                            hoverIcon={hoverIcon6}
                            Title="IT & Software"
                            serviceURL="it-software"
                            Text="Custom software, cloud & DevOps, analytics, and integrations that bring your technical roadmap to life."
                        />
                    </div>
                </div>

                <SectionTitle
                    sectionClass="sec-title2 text-center mb-44"
                    subtitleClass="sub-text"
                    subtitle="Services"
                    titleClass="title testi-title"
                    title="Our Featured Services"
                />
                <div className="row">
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo
                            itemClass="services-item"
                            prefix="01"
                            mainIcon={mainIcon1}
                            hoverIcon={hoverIcon1}
                            Title="Software Development"
                            serviceURL="software-development"
                            Text="Custom software design, development, testing, deployment and ongoing enhancements to scale with your business."
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo
                            itemClass="services-item aqua-bg"
                            prefix="02"
                            mainIcon={mainIcon3}
                            hoverIcon={hoverIcon3}
                            Title="Analytic Solutions"
                            serviceURL="analytic-solutions"
                            Text="Turn data into actionable insight with analytics, reporting, and data engineering tailored to your needs."
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo
                            itemClass="services-item green-bg"
                            prefix="03"
                            mainIcon={mainIcon6}
                            hoverIcon={hoverIcon6}
                            Title="System Integration & Consulting"
                            serviceURL="system-integration"
                            Text="Seamless integrations with third-party systems and enterprise applications to unlock cross-system value."
                        />
                    </div>

                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo
                            itemClass="services-item pink-bg"
                            prefix="04"
                            mainIcon={mainIcon5}
                            hoverIcon={hoverIcon5}
                            Title="Market Analysis & Research"
                            serviceURL="market-analysis"
                            Text="Comprehensive market research and competitive analysis to identify growth opportunities."
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo
                            itemClass="services-item purple-bg"
                            prefix="05"
                            mainIcon={mainIcon2}
                            hoverIcon={hoverIcon2}
                            Title="Business Strategy Development"
                            serviceURL="business-strategy"
                            Text="Strategic planning, go-to-market roadmaps, and operational alignment to achieve business goals."
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo
                            itemClass="services-item paste-bg"
                            prefix="06"
                            mainIcon={mainIcon4}
                            hoverIcon={hoverIcon4}
                            Title="Product Development & Innovation"
                            serviceURL="product-development"
                            Text="End-to-end product ideation, prototyping, and launch support to bring new offerings to market."
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Service;